/**
 *  owners.jsx
 *  @version: 1.0.0
 *  @author: DWIT MÉXICO
 *  @description: Página de todos los propietarios
 */

import React, { Component } from "react";
import { Consumer } from "../context";
import { Helmet } from "react-helmet";
import Header from "../components/header/header";
import Sidebar from "../components/header/sidebar";
import OwnersTable from "../components/propietarios/Owners-Table";
import Paginador from "../components/paginador/paginador";
import Request from "../core/httpClient";
import Controls from "../components/controls/controls";
import DinamicModal from "../components/dinamicModal/dinamicModal";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import Permissions from "../middlewares/Permissions";
import StringHelper from "../helpers/StringHelper";
import cogoToast from "cogo-toast";
import sortableData from "../helpers/sortableDataTable";
import UnifiedDatePicker from '../components/Calendario';
import InputMask from 'react-input-mask';
import moment from "moment-timezone";
const request = new Request();

class Owners extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showModalOwners: false,
			user: { idUsuario: 0, idPerfil: 0, idFraccionamiento: 0 },
			houses: [],
			error: false,
			reload: false,
			fraccionamientoNombre: "",
			propietarios: [],
			idSubfrac: 0,
			searchHouse: false,
			nombre: "",
			pNombre: "",
			pDireccion: "",
			pMunicipio: "",
			pEstado: "",
			pCp: "",
			pTelefono: "",
			pPais: "",
			pGenero: 0,
			pId: 0,
			pNumId: "",
			pVigencia: "",
			pFechaCompra: "",
			pFechaVenta: "",
			pIdPersona: 0,
			pviv: "",
			pidViv: 0,
			page: 1,
			filterData: [],
			filter: "",
			keys: [],
			email: "",
			comentarios: "",
			subfraccionamiento: localStorage.getItem("subfrac") || 0,
			subf: localStorage.getItem("subfrac") || 0,
			fraccionamiento: localStorage.getItem("frac") || 0,
			subfraccionamientos: [],
			city: "",
			residente: false,
			es_residente: false,
			subname: "Subfraccionamiento",
			contact: false,
			viviendasAux: [],
			escritura: false,
			lectura: false,
			viviendasFiltradas: [],
			filter2: "",
			viviendas_json: [],
			persona_existente: true,
			phoneValidated: false,
			viviendas_json_db: [],
			logo: require("../img/logo-AppMosphera-r.png"),
			pageLength: 20,
			direction: {
				nombre: "desc",
				numero_registro: "desc",
			},
			filterColumn: {
				col: "",
				filt: "",
			},
			submenu: '',
			folio: ""
		};
		this.validarPermisos();
	};

	async validarPermisos() {

		let permisos = new Permissions();
		let permisosInfo = await permisos.getResult();

		await this.setState({ escritura: permisosInfo.escritura, lectura: permisosInfo.lectura });
	};

	componentDidUpdate(prevProps, prevState) {

		if (this.state.subfraccionamiento !== prevState.subfraccionamiento) {
			this.getPropietarioFraccionamiento();
		};

		if (this.state.pIdPersona !== prevState.pIdPersona || this.state.pidViv !== prevState.pidViv) {
			this.getFechas();
		};
	};

	reload() {
		this.getSubFraccionamiento();
	};

	/*funcion del paginador*/
	setPage(page) {
		this.setState({ page });
	};

	reloadOwners() {
		this.getPropietarioFraccionamiento();
	};

	change() {
		this.getPropietarioFraccionamiento();
	};

	propietario = (data) => {

		this.setState({
			pNombre: data.nombre,
			pDireccion: data.direccion,
			pMunicipio: data.municipio,
			pEstado: data.estado,
			pCp: data.cp,
			pTelefono: data.telefono,
			pPais: data.pais,
			pGenero: data.genero,
			pId: parseInt(data.tipo_identificacion),
			pNumId: data.num_identificacion,
			pVigencia: data.vigencia_identificacion,
			pIdPersona: data.id_persona,
			search: false,
			comentarios: data.comentarios
		});
	};

	vivienda = (data) => {
		this.setState({
			pviv: data.numero_registro,
			pidViv: data.id_vivienda,
			searchHouse: false,
		});
	};

	subChange(sub) {
		this.setState({ subfraccionamiento: sub, subf: sub });
		this.getViviendas();
	};

	nuevoPropietario() {
		this.setState({ showModalOwners: true });
	};

	setFilter(filter) {
		this.setState({ filter: filter.toLowerCase() });
	};

	async paginatorChange(length) {

		await this.setState({ pageLength: length });

		this.setPage(1);
	};

	filter(propietarios) {

		propietarios = propietarios.filter((pro) => {

			if (pro.nombre.toLowerCase().indexOf(this.state.filter) !== -1) {
				return true;
			} else if (pro.telefono.toLowerCase().indexOf(this.state.filter) !== -1) {
				return true;
			} else if (pro.numero_registro.toLowerCase().indexOf(this.state.filter) !== -1) {
				return true;
			} else if (pro.email.toLowerCase().indexOf(this.state.filter) !== -1) {
				return true;
			} else {
				return false;
			};

		});

		return propietarios;
	};

	sortableTable(key) {

		let sd = new sortableData();

		const { items, direction } = sd.sortBy(key, this.state.propietarios, this.state.direction[key]);

		this.setState({
			subfraccionamientos: items,
			direction: {
				[key]: direction,
			},
			filterColumn: {
				col: key,
				filt: direction,
			},
		});
	};

	render() {

		let propietarios = [];

		if (this.state.propietarios) {
			propietarios = this.state.propietarios;
			propietarios = this.filter(propietarios);
		};

		return (
			<div className="owners column">
				<Helmet>
					<title>{process.env.REACT_APP_NAME} - {this.state.submenu}</title>
				</Helmet>
				<Header reload={this.reload.bind(this)} change={this.change.bind(this)} sidebar={true} active={"propietarios"} parent={"admin"} panel={"panel1"} nav={"catalogos"} />

				<div className="row">
					<div className="column" id="sidebar">
						<Sidebar />
					</div>
					<div className="column" id="content">
						<div className="justify-center">
							<div className="container column">
								{this.state.lectura ? (
									<React.Fragment>
										<Controls
											title={this.state.submenu}
											nuevo={this.openModal.bind(this, "newOwner")}
											dataSet={propietarios}
											setFilter={this.setFilter.bind(this)}
											subChange={this.subChange.bind(this)}
											newButton={this.state.escritura}
										/>

										{this.state.loadingPropietarios ? (
											<div className="row justify-center">
												<i className="fas fa-spinner fa-spin"></i>
											</div>
										) : (
											<OwnersTable
												reload={this.getPropietarioFraccionamiento.bind(this)}
												data={propietarios}
												page={this.state.page}
												reloadOwners={this.reloadOwners.bind(this)}
												escritura={this.state.escritura}
												pageLength={this.state.pageLength}
												sortBy={this.sortableTable.bind(this)}
												filterColumn={this.state.filterColumn}
												subLabel={this.state.subLabel}
											/>
										)}
										<div className="white-space-16" />
										<Paginador
											pages={Math.ceil(propietarios.length / this.state.pageLength)}
											setPage={this.setPage.bind(this)}
											pageLength={this.state.pageLength}
											paginatorChange={this.paginatorChange.bind(this)}
											showPageLenght={true}
										/>
									</React.Fragment>
								) : null}
							</div>
						</div>

						<DinamicModal
							idModal={"newOwner"}
							sizeModalContainer={"super"}
							title={"Añadir propietario"}
							success={this.handledSubmit.bind(this)}
							showBtnSuccess={true}
							btnTextSuccess={"GUARDAR"}
							showBtnCancel={true}
							btnTextCancel={"CANCELAR"}
							closeModal={this.resetValue.bind(this)}
							loadingSave={this.state.loading}
							message={this.state.message}
							disabledBtnSuccess={!this.state.phoneValidated}
						>
							{/* {this.renderNewOwner()} */}
							{this.formContactosViviendas()}
						</DinamicModal>
					</div>
				</div>
			</div>
		);
	};

	componentDidMount() {
		this.getSubmenu();
		this.getPropietarioFraccionamiento();
		this.getPersonas();
		this.getSubFraccionamientos();
		this.getViviendas();
	};

	async getSubmenu() {

		const submenu = await this.props.context.getSubmenuName();

		if (submenu) {
			this.setState({ submenu });
		};

		const subLabel = window.localStorage.getItem('subLabel');

		if (subLabel) {
			this.setState({ subLabel });
		};

	};

	async openModal(idModal) {

		this.resetValue();

		await this.clearCheckboxs();
		await this.getViviendas();
		await this.setState({ viviendasFiltradas: this.state.viviendas });
		await this.buscarViviendas();

		this.setState({ message: null });

		const modal = document.getElementById(idModal);

		if (modal) {
			modal.classList.remove("hide-dinamic-modal");
			modal.classList.add("show-dinamic-modal");
		};

		let foc = document.getElementById("unidad");

		if (foc) {
			foc.focus();
		};

	};

	async resetValue() {

		await this.setState({
			pidViv: "",
			pNombre: "",
			pTelefono: "",
			pGenero: "",
			email: "",
			pId: "",
			pNumId: "",
			pDireccion: "",
			pMunicipio: "",
			pCp: "",
			pEstado: "",
			pPais: "",
			pFechaCompra: "",
			pFechaVenta: "",
			contact: false,
			residente: false,
			city: "",
			viviendasJSON: [],
			comentarios: ""
		});
	};

	async changeUnidad(event) {

		let viv = event.target.value;

		let vivienda = [];

		this.state.viviendas.find((v) => {

			if (v.id_vivienda == viv) {
				vivienda = v;
			};
		});

		await this.setState({ pidViv: viv, pDireccion: vivienda.direccion });

	};

	async filtrarViviendas() {

		let viviendas = this.state.viviendas;
		let vivs = [];

		if (this.state.subf == 0) {

			if (this.state.subfraccionamientos.length !== 0) {
				await this.setState({ subf: this.state.subfraccionamientos[0].id_subfraccionamiento });
			} else {
				return [];
			};
		};

		viviendas.map((viv) => {
			if (viv.id_subfraccionamiento == this.state.subf) {
				vivs.push(viv);
			};
		});

		await this.setState({ viviendasFiltradas: vivs });
	};

	async buscarViviendas(event) {

		if (event) await this.setState({ filter2: event.target.value });

		await this.filtrarViviendas();

		if (this.state.filter2 !== "") {

			let sh = new StringHelper();

			// todas las viviendas
			let viviendas = this.state.viviendasFiltradas;

			let viviendasBuscadas = viviendas.map((viv) => {

				let vivienda = sh.eliminarCaracteresRaros(viv.numero_registro, true);
				let datosBusqueda = sh.eliminarCaracteresRaros(this.state.filter2);

				if (sh.multiMatch(vivienda, datosBusqueda)) {
					return viv;
				};

			});

			// quito datos undefined
			viviendasBuscadas = viviendasBuscadas.filter((item) => item !== undefined);

			await this.setState({ viviendasFiltradas: viviendasBuscadas });

			this.checkViviendas();
		} else {
			this.checkViviendas();
		};

	};

	checkViviendas() {

		this.clearCheckboxs();

		let checks = document.getElementsByName("viviendas-check");

		checks.forEach((check) => {

			try {

				let id = check.getAttribute("id").split("-")[1];

				// Buscar id en las viviendas de la persona y marcarlo
				if (this.state.viviendas_json_db) {

					this.state.viviendas_json_db.forEach((viv) => {

						if (parseInt(viv.id_vivienda) == parseInt(id)) {
							check.checked = true;
						};

					});
				};

			} catch (error) {
				//console.log(error);
			};

		});
	};

	async changeSubFrac() {

		//let subf 		=  event.target.value;
		let vivs = [];
		//await this.setState({subf:	subf});
		await this.buscarViviendas();
		await this.clearCheckboxs();
		this.checkViviendas();
	};

	async clearCheckboxs() {

		let checks = document.getElementsByName("viviendas-check");

		checks.forEach((check) => {
			check.checked = false;
		});
	};

	async filtarViviendas() {

		let viviendas = this.state.viviendas;
		let vivs = [];

		if (this.state.subf == 0) {

			if (this.state.subfraccionamientos.length !== 0) {
				await this.setState({ subf: this.state.subfraccionamientos[0].id_subfraccionamiento });
			} else {
				return [];
			};
		};

		viviendas.map((viv) => {

			if (viv.id_subfraccionamiento == this.state.subf) {
				vivs.push(viv);
			};
		});

		return vivs;
	};

	async validarTelefono(telefono) {

		this.setState({ loadingVlidatePhone: true, phoneValidated: false });

		if (isValidPhoneNumber(telefono)) {

			const data = {
				telefono,
				id_fraccionamiento: this.state.fraccionamiento,
			};

			const res = await request.post("/personas/getbyphone", data);

			const { persona } = res;

			if (persona) {

				this.setState({
					pNombre: persona.nombre || "",
					email: persona.email || "",
					pGenero: persona.genero || 0,
					pDireccion: persona.direccion || "",
					pCp: persona.cp || "",
					city: persona.ciudad || "",
					pMunicipio: persona.municipio || "",
					pEstado: persona.estado || "",
					pPais: persona.pais || "",
					pId: persona.tipo_identificacion || 0,
					pNumId: persona.num_identificacion || "",
					pIdPersona: persona.id_persona || 0,
					persona_existente: persona.encontrado,
					comentarios: persona.comentarios || "",
					es_residente: persona.es_residente || false
				});

			} else {

				this.setState({
					pNombre: "",
					email: "",
					pGenero: 0,
					pDireccion: "",
					pCp: "",
					city: "",
					pMunicipio: "",
					pEstado: "",
					pPais: "",
					pId: 0,
					pNumId: "",
					pIdPersona: 0,
					persona_existente: false,
					comentarios: "",
					es_residente: false
				});
			};

			this.setState({ phoneValidated: true });

		} else {
			cogoToast.warn("Número de teléfono inválido.", {
				position: "bottom-right",
			});
		};

		this.setState({ loadingVlidatePhone: false });
	};

	renderNewOwner() {
		const {
			subLabel, subfraccionamientos, subf, subfraccionamiento,
			pTelefono, telefonoError, loadingVlidatePhone,
			pNombre, persona_existente,
			pGenero, email,
			pId, pNumId,
			pDireccion,
			pMunicipio, city,
			pCp, pEstado,
			pPais,
			pFechaCompra, pFechaVenta,
			comentarios, residente
		} = this.state;

		const fechaCompraObj = pFechaCompra && moment(pFechaCompra, 'YYYY-MM-DD', true).isValid()
			? moment(pFechaCompra, 'YYYY-MM-DD', true).toDate()
			: null;

		const fechaVentaObj = pFechaVenta && moment(pFechaVenta, 'YYYY-MM-DD', true).isValid()
			? moment(pFechaVenta, 'YYYY-MM-DD', true).toDate()
			: null;

		return (
			<div className="w-full space-y-2">
				{/* Fila 1: Subfraccionamiento + botón Cambiar */}
				<div className="flex items-center gap-2">
					<label className="w-36 text-sm font-bold flex-shrink-0 whitespace-nowrap">{subLabel}:</label>
					<select
						className={`flex-1 px-2.5 py-1 border rounded text-sm ${subfraccionamiento === 0 ? "bg-gray-100" : "bg-white"}`}
						value={subf}
						onChange={(e) => this.setState({ subf: e.target.value })}
						disabled={subfraccionamiento !== 0}
					>
						{subfraccionamientos.map((viv) => (
							<option key={viv.id_subfraccionamiento} value={viv.id_subfraccionamiento}>
								{viv.nombre}
							</option>
						))}
					</select>
					{subfraccionamientos.length > 1 && subfraccionamiento === 0 && (
						<button
							type="button"
							className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 whitespace-nowrap"
							onClick={this.changeSubFrac.bind(this)}
						>
							Cambiar
						</button>
					)}
				</div>

				{/* Fila 2: Teléfono + botón Validar */}
				<div className="flex items-center gap-2">
					<label className="w-36 text-sm font-bold flex-shrink-0 whitespace-nowrap">
						Teléfono: <span className="text-red-500">*</span>
					</label>
					<PhoneInput
						className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
						defaultCountry="MX"
						value={pTelefono}
						onChange={(value) => this.setState({ pTelefono: value, telefonoError: undefined, phoneValidated: false })}
						error={telefonoError}
					/>
					<button
						disabled={loadingVlidatePhone}
						type="button"
						className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 disabled:opacity-50 whitespace-nowrap"
						onClick={this.validarTelefono.bind(this, pTelefono)}
					>
						{loadingVlidatePhone ? <i className="fas fa-spinner fa-spin"></i> : "Validar"}
					</button>
				</div>

				{/* Fila 3: Nombre completo */}
				<div className="flex items-center gap-2">
					<label className="w-36 text-sm font-bold flex-shrink-0 whitespace-nowrap">
						Nombre: <span className="text-red-500">*</span>
					</label>
					<input
						type="text"
						value={pNombre}
						onChange={(e) => this.setState({ pNombre: e.target.value })}
						disabled={persona_existente}
						className={`flex-1 px-2.5 py-1 border rounded text-sm ${persona_existente ? "bg-white" : "bg-gray-100"}`}
					/>
				</div>

				{/* Fila 4: Género + Correo (2 columnas) */}
				<div className="grid grid-cols-2 gap-2">
					<div className="flex items-center gap-2">
						<label className="w-20 text-sm font-bold flex-shrink-0 whitespace-nowrap">Género:</label>
						<select
							value={pGenero}
							onChange={(e) => this.setState({ pGenero: e.target.value })}
							className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
						>
							<option value="0">Hombre</option>
							<option value="1">Mujer</option>
							<option value="2">No especificado</option>
						</select>
					</div>
					<div className="flex items-center gap-2">
						<label className="w-20 text-sm font-bold flex-shrink-0 whitespace-nowrap">Correo:</label>
						<input
							type="email"
							value={email}
							onChange={(e) => this.setState({ email: e.target.value })}
							className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
						/>
					</div>
				</div>

				{/* Fila 5: Identificación + ID (2 columnas) */}
				<div className="grid grid-cols-2 gap-2">
					<div className="flex items-center gap-2">
						<label className="w-20 text-sm font-bold flex-shrink-0 whitespace-nowrap">Identif.:</label>
						<select
							value={pId}
							onChange={(e) => this.setState({ pId: e.target.value })}
							className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
						>
							<option value="0">INE</option>
							<option value="1">Pasaporte/Visa</option>
							<option value="2">Curp</option>
							<option value="3">Cartilla Militar</option>
						</select>
					</div>
					<div className="flex items-center gap-2">
						<label className="w-20 text-sm font-bold flex-shrink-0 whitespace-nowrap">ID:</label>
						<input
							type="text"
							value={pNumId}
							onChange={(e) => this.setState({ pNumId: e.target.value })}
							className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
						/>
					</div>
				</div>

				{/* Fila 6: Dirección */}
				<div className="flex items-center gap-2">
					<label className="w-20 text-sm font-bold flex-shrink-0 whitespace-nowrap ">Dirección:</label>
					<input
						type="text"
						value={pDireccion}
						onChange={(e) => this.setState({ pDireccion: e.target.value })}
						className="flex-1 px-1 py-1 border rounded bg-gray-100 text-sm "
					/>
				</div>

				{/* Fila 7: Municipio + Ciudad (2 columnas) */}
				<div className="grid grid-cols-2 gap-2">
					<div className="flex items-center gap-2">
						<label className="w-20 text-sm font-bold flex-shrink-0 whitespace-nowrap">Municipio:</label>
						<input
							type="text"
							value={pMunicipio}
							onChange={(e) => this.setState({ pMunicipio: e.target.value })}
							className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
						/>
					</div>
					<div className="flex items-center gap-2">
						<label className="w-20 text-sm font-bold flex-shrink-0 whitespace-nowrap">Ciudad:</label>
						<input
							type="text"
							value={city}
							onChange={(e) => this.setState({ city: e.target.value })}
							className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
						/>
					</div>
				</div>

				{/* Fila 8: CP + Estado (2 columnas) */}
				<div className="grid grid-cols-2 gap-2">
					<div className="flex items-center gap-2">
						<label className="w-20 text-sm font-bold flex-shrink-0 whitespace-nowrap">C.P:</label>
						<input
							type="text"
							value={pCp}
							onChange={(e) => this.setState({ pCp: e.target.value })}
							className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
						/>
					</div>
					<div className="flex items-center gap-2">
						<label className="w-20 text-sm font-bold flex-shrink-0 whitespace-nowrap">Estado:</label>
						<input
							type="text"
							value={pEstado}
							onChange={(e) => this.setState({ pEstado: e.target.value })}
							className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
						/>
					</div>
				</div>

				{/* Fila 9: País */}
				<div className="flex items-center gap-2">
					<label className="w-20 text-sm font-bold flex-shrink-0 whitespace-nowrap">País:</label>
					<input
						type="text"
						value={pPais}
						onChange={(e) => this.setState({ pPais: e.target.value })}
						className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
					/>
				</div>

				{/* Fila 10: Fechas (2 columnas) */}
				<div className="grid grid-cols-2 gap-2">
					<div className="flex items-center gap-2">
						<label className="w-24 text-sm font-bold flex-shrink-0 whitespace-nowrap">
							F. compra: <span className="text-red-500">*</span>
						</label>
						<UnifiedDatePicker
							selected={fechaCompraObj}
							onChange={(date) => {
								const formatted = date ? moment(date).format('YYYY-MM-DD') : '';
								this.setState({ pFechaCompra: formatted });
							}}
							includeTime={false}
							dateFormat="dd/MM/yyyy"
							placeholderText="DD/MM/YYYY"
							className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
							customInput={
								<InputMask
									mask="99/99/9999"
									maskChar={null}
									className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
									placeholder="DD/MM/YYYY"
								/>
							}
						/>
					</div>
					<div className="flex items-center gap-2">
						<label className="w-24 text-sm font-bold flex-shrink-0 whitespace-nowrap">F. venta:</label>
						<UnifiedDatePicker
							selected={fechaVentaObj}
							onChange={(date) => {
								const formatted = date ? moment(date).format('YYYY-MM-DD') : '';
								this.setState({ pFechaVenta: formatted });
							}}
							includeTime={false}
							dateFormat="dd/MM/yyyy"
							placeholderText="DD/MM/YYYY"
							className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
							customInput={
								<InputMask
									mask="99/99/9999"
									maskChar={null}
									className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm"
									placeholder="DD/MM/YYYY"
								/>
							}
						/>
					</div>
				</div>

				{/* Fila 11: Comentarios */}
				<div className="flex items-start gap-2">
					<label className="w-22	 text-sm font-bold flex-shrink-0 whitespace-nowrap pt-1">Comentarios:</label>
					<textarea
						value={comentarios}
						onChange={(e) => this.setState({ comentarios: e.target.value })}
						rows="2"
						className="flex-1 px-2.5 py-1 border rounded bg-gray-100 text-sm resize-none"
					/>
				</div>

				{/* Fila 12: Checkbox de residente + nota */}
				<div className="flex items-center justify-between text-sm">
					<label className="flex items-center gap-2">
						<input
							type="checkbox"
							checked={residente}
							onChange={(e) => this.setState({ residente: e.target.checked })}
							className="h-4 w-4"
						/>
						<span className="font-small">Añadir propietario como residente</span>
					</label>
					<span className="text-gray-500">
						<span className="text-red-500">*</span> obligatorio
					</span>
				</div>
			</div>
		);
	}

	async clearFilter() {
		await this.setState({ filter2: "" });
		await this.filtrarViviendas();

		this.checkViviendas();
	};

	formContactosViviendas() {
		return (
			<div className="flex flex-col md:flex-row w-full space-x-6">
				{/* Panel izquierdo: nuevo propietario */}
				<div className="flex-1">
					<div className="p-4 bg-white rounded shadow">
						{this.renderNewOwner()}
					</div>
				</div>

				{/* Panel derecho: viviendas */}
				<div className="flex-1">
					<div className="p-4 bg-white rounded shadow">
						<div className="flex items-center justify-between mb-4">
							<h4 className="text-lg font-semibold">Viviendas</h4>
							<div className="relative">
								<input
									type="text"
									value={this.state.filter2}
									onChange={(event) => this.buscarViviendas(event)}
									className="w-48 px-3 py-1 border border-gray-300 rounded bg-neutral-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
									placeholder="Buscar..."
								/>
								<i className="fas fa-search absolute right-2 top-2 text-gray-500 text-sm"></i>
							</div>
						</div>

						{/* Lista de viviendas */}
						<div className="space-y-2">
							{this.state.subf !== 0 && this.state.viviendasFiltradas.length !== 0 ? (
								this.state.viviendasFiltradas.map((viv) => (
									<div
										key={viv.id_vivienda}
										className="flex items-center justify-between px-3 py-2 border border-gray-200 rounded hover:bg-gray-50"
									>
										<label htmlFor={`check-${viv.id_vivienda}`} className="font-medium text-sm text-gray-700">
											{viv.numero_registro}
										</label>
										<div>
											<input
												type="checkbox"
												name="viviendas-check"
												id={`check-${viv.id_vivienda}`}
												onClick={this.addCheck.bind(this, viv.id_vivienda)}
												className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
											/>
										</div>
									</div>
								))
							) : (
								<div className="flex justify-center items-center py-6">
									<h4 className="text-gray-600">No hay unidades para mostrar.</h4>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);

	};

	getChecksChecked(checks) {
		let checksChecked = [];
		if (checks.length <= 0) {
			return checksChecked;
		}
		checks.forEach((check) => {
			let subfrac = parseInt(this.state.subf);
			if (!check.subf || parseInt(check.subf) === subfrac) {
				try {
					// {id_vivienda: 80, subf: 25}
					checksChecked.push(check.id_vivienda);
				} catch (err) {
					//console.log(err);
				}
			}
		});
		return checksChecked;
	};

	async addCheck(id) {
		let jsons_viv = this.state.viviendas_json_db;
		let check = document.getElementById(`check-${id}`);

		let address = this.state.viviendasFiltradas.filter((viv) => viv.id_vivienda == id);
		if (address.length > 0) {
			if (this.state.pDireccion == "") {
				this.setState({ pDireccion: address[0].direccion });
			}
		}

		if (check.checked) {
			if (!jsons_viv) jsons_viv = [];
			jsons_viv.push({ id_vivienda: id, subf: parseInt(this.state.subf) });
		} else {
			for (var i = 0; i < jsons_viv.length; i++) {
				if (parseInt(jsons_viv[i].id_vivienda) === parseInt(id)) {
					jsons_viv.splice(i, 1);
					break;
				}
			}
		}
	};

	/**
	 * Filtrar viviendas seleccionadas cuando por defecto se
	 * traen viviendas que ya tiene una persona de otro
	 * subfraccioamiento
	 */
	filtrarViviendasSeleccionadas(jsonNoFiltrado) {
		let id_sub = parseInt(this.state.subf);
		let viviendasPorFraccionamiento = [];

		this.state.viviendas.forEach((viv) => {
			if (parseInt(viv.id_subfraccionamiento) == id_sub) {
				viviendasPorFraccionamiento.push(viv.id_vivienda);
			}
		});

		let viviendasFiltradas = [];

		jsonNoFiltrado.forEach((viv) => {
			if (viviendasPorFraccionamiento.includes(viv)) {
				viviendasFiltradas.push(viv);
			}
		});

		return viviendasFiltradas;
	};

	//traer Propietarios del fraccionaiento
	async getPropietarioFraccionamiento() {
		this.setState({ loadingPropietarios: true });
		let IdSub = this.state.subfraccionamiento;
		const idFrac = localStorage.getItem("frac");

		let data = { IdSub, idFrac };

		const response = await request.post("/fraccionamientos/get/propietarios", data);

		if (response && !response.error) {
			if (response.propietario && !response.empty) {
				const propietarios = response.propietario;
				this.setState({
					propietarios,
					filterData: propietarios,
				});
			} else {
				this.setState({
					propietarios: [],
					empty: true,
					message: response.message,
				});
			}
		} else {
			this.setState({
				error: true,
				message: response.message,
			});
		}
		this.setState({ loadingPropietarios: false });
	};

	async handledSubmit(event) {
		event.preventDefault();
		this.setState({ loading: true, message: "" });

		let checks = this.state.viviendas_json_db;
		let checksJson = this.getChecksChecked(checks);

		let jsonSTR = this.filtrarViviendasSeleccionadas(checksJson);

		/**Validar Vivienda */
		if (!(jsonSTR.length > 0)) {
			cogoToast.warn("Debes seleccionar una vivienda.", {
				position: "bottom-right",
			});
			await this.setState({ loading: false });
			return;
		}

		/**Validar Vivienda */
		// if (!(this.state.pidViv > 0)) {
		// 	this.setState({loading: false});
		//     alert("Para continuar debes seleccionar una vivienda")
		//     return;
		// }

		if (!(this.state.subf > 0)) {
			this.setState({ loading: false });
			cogoToast.warn("Debes seleccionar un subfraccionamiento.", {
				position: "bottom-right",
			});
			return;
		}
		/**Validar Telefono */
		if (!isValidPhoneNumber(this.state.pTelefono)) {
			this.setState({ telefonoError: "Número inválido", loading: false });
			return;
		} else {
			this.setState({ telefonoError: undefined });
		}

		let resident = this.state.es_residente ? 1 : 0;
		let contact = 0; //document.getElementById('contact').checked ? 1:0;
		let data = {
			// IdViv: 				this.state.pidViv,
			viviendasJSON: JSON.stringify(jsonSTR),
			Nombre: this.state.pNombre,
			Direccion: this.state.pDireccion,
			Municipio: this.state.pMunicipio,
			Estado: this.state.pEstado,
			Cp: this.state.pCp,
			Telefono: this.state.pTelefono,
			Pais: this.state.pPais,
			Genero: parseInt(this.state.pGenero),
			TipoId: parseInt(this.state.pId),
			NumId: this.state.pNumId,
			Vigencia: this.state.pVigencia,
			FechaCompra: this.state.pFechaCompra,   // ← ahora usa el estado
			FechaVenta: this.state.pFechaVenta,     // ← ahora usa el estado
			idPersona: this.state.pIdPersona,
			email: this.state.email,
			idFraccionamiento: parseInt(localStorage.getItem("frac") || 0),
			city: this.state.city,
			residente: resident,
			contacto: contact,
			comentarios: this.state.comentarios,
			id_usuario_add: localStorage.getItem("user_id")
		};
		const response = await request.post("/propietarios/propietario/create", data);

		if (response.created) {
			this.getPropietarioFraccionamiento();
			this.getViviendas();
			const modal = document.getElementById("newOwner");
			if (modal) {
				modal.classList.add("hide-dinamic-modal");
				modal.classList.remove("show-dinamic-modal");
			}
			await this.setState({ loading: false /*, message: 'PROPIETARIO AÑADIDO' */ });
			cogoToast.success("Propietario añadido.", {
				position: "bottom-right",
			});
		} else {
			this.setState({ loading: false /*,message: "NO SE PUDO AÑADIR PROPIETARIO"*/ });
			cogoToast.error("No se pudo añadir propietario.", {
				position: "bottom-right",
			});
		}
		this.setState({ loading: false });
	};

	handleOpen() {
		this.setState({ showModalOwners: true });
	};

	handleClose() {
		this.setState({
			showModalOwners: false,
			pNombre: "",
			pDireccion: "",
			pMunicipio: "",
			pEstado: "",
			pCp: "",
			pTelefono: "",
			pPais: "",
			pGenero: "",
			pId: 0,
			pNumId: "",
			pVigencia: "",
			pFechaCompra: "",
			pIdPersona: 0,
			edditProp: false,
			pviv: "",
			email: "",
			comentarios: ""
		});
	};

	async getPersonas() {
		// alert("persona obtenida");
		const response = await request.post("/personas/getbyfraccionamiento", { id_fraccionamiento: localStorage.getItem("frac") });
		if (Array.isArray(response.personas)) {
			this.setState({ personas: response.personas });
		} else {
			this.setState({ personas: [] });
		}
	};

	async getSubFraccionamientos() {
		const fraccionamiento = localStorage.getItem("frac");
		if (!fraccionamiento) {
			return;
		}
		let data = { Idsub: fraccionamiento, filter: 1 };
		const response = await request.post("/admin/administracion/get/subfraccionamientos", data);
		if (response.subfraccionamiento) {
			this.setState({ subfraccionamientos: response.subfraccionamiento });
		} else {
			this.setState({ subfraccionamientos: [] });
		}
	};

	async getViviendas() {
		let data = {
			id_fraccionamiento: localStorage.getItem("frac"),
			id_subfraccionamiento: localStorage.getItem("subfrac"),
		};

		const response = await request.post("/viviendas/getVivienda/sinpropietario", data);
		//console.log(response);
		if (Array.isArray(response.viviendas)) {
			await this.setState({ viviendas: response.viviendas, viviendasAux: response.viviendas, subname: response.viviendas[0].nombre_subfrac });
		} else {
			this.setState({ viviendas: [] });
		}
	};

	async getFechas() {
		const res = await request.post("/propietarios/get/fechas", { IdPersona: this.state.pIdPersona, IdViv: this.state.pidViv });
		if (res.dates) {
			this.setState({
				pFechaCompra: res.dates.fecha_compra || "",
				pFechaVenta: res.dates.fecha_venta || "",
			});
		}
	};

};

export default Consumer(Owners);